import { Vue, Component } from "vue-property-decorator";
import { sortBy } from "lodash";
import { ReportsModule } from "@/modules/reports-objective";
import { fmtMsg, ActionItem } from "commonui";
import { Checkbox, Dropdown, Menu, Icon, Button } from "ant-design-vue";
import { ReportsLocale } from "@/locales/localeid";
import Spinning from "@/components/spinning/spinning.vue";
import VersionGroupUnitsSelect from "@/components/version-group-units-select/version-group-units-select.vue";
import { AccessLevel, ExportType } from "@/util/enum";
import { disabledDueToAccessLevel, getRouteAccessLevel } from "@/util/func";

@Component({
	components: {
		Checkbox,
		Spinning,
		ActionItem,
		VersionGroupUnitsSelect,
		Dropdown,
		Menu,
		MenuItem: Menu.Item,
		Icon,
		Button
	}
})
export default class HeaderActions extends Vue {
	public accessLevel = AccessLevel;

	mounted() {
		ReportsModule.setShowObjectiveDetail(false);
	}

	get reportModule() {
		return ReportsModule;
	}

	get vcsLevelUnits() {
		return sortBy(ReportsModule.vcsUnits, "unit");
	}

	get exportType() {
		return ExportType;
	}

	get currentRouteAccessLevel() {
		return getRouteAccessLevel(this.$route);
	}

	get disabledDueToAccessLevel() {
		return disabledDueToAccessLevel(this.currentRouteAccessLevel);
	}

	onObjectiveNumberCheck(e) {
		ReportsModule.setShowObjectiveNumber(e.target.checked);
	}

	get reportsLocale() {
		return ReportsLocale;
	}

	setUnitObject(value) {
		ReportsModule.setSelectedUnits(value);
	}

	onCheck(e) {
		ReportsModule.setShowObjectiveDetail(e.target.checked);
	}

	handleExport(e) {
		ReportsModule.exportObjective(e.key);
	}
}
